import React, { Fragment } from 'react';

import { t } from '../../../../../../modules/infra/i18n';
import Checkbox from '../../../../../common/Checkbox';

const generateMatchesColumns = (
  {
    allSelected,
    isSelected,
    matchesInitialized,
    noMatches,
    onChange,
    onSelectAll,
    selectable,
}) => [
  {
    Header: (
      <div
        className="vendor-matches-table__sort__item"
        role="button"
      >
        <Checkbox
          className="u-margin-0"
          disabled={noMatches || !matchesInitialized}
          display-if={selectable}
          checked={allSelected}
          onChange={onSelectAll}
        />
        <div className="matches-table__with-sorting">{t('products:shopify.matching_sku_header')}</div>
      </div>
    ),
    accessor: 'sku',
    Cell: row => (
      <Fragment>
        <Checkbox
          className="u-margin-0"
          display-if={selectable}
          checked={isSelected(row.original)}
          onChange={() => onChange(row.original)}
        />
        {row.value}
      </Fragment>
    ),
    width: 270,
  },
  {
    Header: (
      <div
        className="vendor-matches-table__sort__item"
        role="button"
      >
        <div className="matches-table__with-sorting">{t('products:shopify.name_in_squire_header')}</div>
      </div>
    ),
    accessor: 'squireName',
    width: 230,
  },
  {
    Header: (
      <div
        className="vendor-matches-table__sort__item"
        role="button"
      >
        <div className="matches-table__with-sorting">{t('products:shopify.name_in_shopify_header')}</div>
      </div>
    ),
    accessor: 'shopifyName',
    width: 230,
  },
];

export default generateMatchesColumns;
